package com.kinoshazam.screens.main.compact

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.itemsIndexed
import androidx.compose.foundation.lazy.grid.rememberLazyGridState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.components.videoItem.CompactVideoItem
import com.kinoshazam.uiKit.components.videoItem.compactBannerSkeletons
import com.kinoshazam.uiKit.components.videoItem.VideoState
import com.kinoshazam.screens.main.FavoriteSyncStatus
import com.kinoshazam.uiKit.theme.Large
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.favorite_empty
import kinoshazam.resources.generated.resources.movie
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import presentation.screens.main.MainMVIAction
import presentation.screens.main.MainState

@Composable
fun FavoriteContent(
    paddingValues: PaddingValues,
    state: MainState,
    onAction: (MainMVIAction) -> Unit,
) {
    val scrollState = rememberLazyGridState()
    val fetchNextPage: Boolean by remember {
        derivedStateOf {
            val currentVideoCount = scrollState.layoutInfo.totalItemsCount - 1
            val lastVisibleIndex =
                scrollState.layoutInfo.visibleItemsInfo.lastOrNull()?.index
                    ?: return@derivedStateOf false
            return@derivedStateOf lastVisibleIndex >= currentVideoCount - 5
        }
    }

    LaunchedEffect(key1 = fetchNextPage) {
        if (fetchNextPage) {
            onAction(MainMVIAction.FetchNextPage)
        }
    }
    Column(
        modifier = Modifier.padding(paddingValues),
    ) {
        FavoriteSyncStatus(state)

        val favorites = state.favoriteList
        if (favorites == null) {
            LazyVerticalGrid(
                modifier = Modifier.padding(horizontal = 48.dp),
                verticalArrangement = Arrangement.spacedBy(4.dp),
                horizontalArrangement = Arrangement.spacedBy(4.dp),
                columns = GridCells.Adaptive(minSize = 128.dp),
                contentPadding = PaddingValues(top = 16.dp, bottom = 32.dp),
            ) {
                compactBannerSkeletons()
            }
        } else if (favorites.isEmpty()) {
            Box(
                modifier = Modifier.fillMaxSize(),
                contentAlignment = Alignment.Center,
            ) {
                TextLabel(
                    state = TextLabelState(
                        text = stringResource(Res.string.favorite_empty),
                        color = UiKitTheme.colors.color_2,
                        textStyle = Large,
                    )
                )
            }
        } else {

            LazyVerticalGrid(
                state = scrollState,
                modifier = Modifier
                    .padding(horizontal = 48.dp), // TODO: add inset padding in landscape
                verticalArrangement = Arrangement.spacedBy(4.dp),
                horizontalArrangement = Arrangement.spacedBy(4.dp),
                columns = GridCells.Adaptive(minSize = 128.dp),
                contentPadding = PaddingValues(
                    top = 16.dp,
                    bottom = 32.dp
//                bottom = WindowInsets.navigationBars.asPaddingValues()
//                    .calculateBottomPadding() + 32.dp,
                ),
            ) {
                itemsIndexed(state.favoriteList ?: emptyList()) { index, video ->
                    CompactVideoItem(
                        state = VideoState(
                            id = video.videoId.toInt() ?: -1,
                            title = video.title.orEmpty(),
                            image = video.imageUrl,
                            placeHolder = painterResource(Res.drawable.movie),
                            placeHolderColor = UiKitTheme.colors.color_5,
                            onAction = { id ->
                                if (video.isTvShow) {
                                    onAction(MainMVIAction.OnTvShowClicked(id))
                                } else {
                                    onAction(MainMVIAction.OnDetailsClicked(id))
                                }
                            }
                        ),
                    )
                }

                if (state.isNextLoading) {
                    item {
                        Text(
                            text = "Load next page",
                            color = UiKitTheme.colors.color_2,
                        )
                    }
                }
            }
        }
    }
}